export default "__VITE_ASSET__C3pHe3qM__"